import * as React from "react"
import * as SwitchPrimitives from "@radix-ui/react-switch"

import { cn } from "@/lib/utils"

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
>(({ className, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      "peer inline-flex h-4 w-7 shrink-0 cursor-pointer items-center rounded-full border border-transparent transition-all duration-200 ease-out",
      "shadow-[inset_0_0.5px_1px_rgba(0,0,0,0.06)]",
      "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/20 focus-visible:ring-offset-1 focus-visible:ring-offset-background",
      "disabled:cursor-not-allowed disabled:opacity-50",
      "data-[state=checked]:bg-foreground",
      "data-[state=unchecked]:bg-muted/80",
      className
    )}
    {...props}
    ref={ref}
  >
    <SwitchPrimitives.Thumb
      className={cn(
        // Thumb takes the page colour so it reads on the ink track in both themes.
        "pointer-events-none block h-3 w-3 rounded-full bg-white transition-all duration-200 ease-out dark:data-[state=checked]:bg-background dark:data-[state=unchecked]:bg-white/70",
        "shadow-[0_0.5px_2px_rgba(0,0,0,0.1)]",
        "data-[state=checked]:translate-x-[13px] data-[state=unchecked]:translate-x-0.5"
      )}
    />
  </SwitchPrimitives.Root>
))
Switch.displayName = SwitchPrimitives.Root.displayName

export { Switch }
